import { Theme } from '@easeltv/client-sdk';
import styled, { useTheme } from 'styled-components';

const StyledLogoImage = styled.img`
    object-fit: contain;
    max-width: 100%;
`;

type LogoSections = Pick<
    Theme['sections'],
    'header' | 'menu' | 'page' | 'footer' | 'sideMenu'
>;

export const useLogoImage = (
    width = 200,
    height = 40,
    subSection: keyof LogoSections = 'header',
) => {
    const theme = useTheme();

    const imageId = theme.sections[subSection].logoImageId;

    if (!imageId) return null;

    const cdnLink = theme.sections.links.image ?? '';
    const logo = cdnLink
        .replace('rendition/{imageRenditionId}', imageId)
        .replace('{height}', `${height}`)
        .replace('{width}', `${width}`)
        .replace('{format}', 'webp')
        .replace('{mode}', 'fit');

    const logoRetina = cdnLink
        .replace('rendition/{imageRenditionId}', imageId)
        .replace('{height}', `${height * 2}`)
        .replace('{width}', `${width * 2}`)
        .replace('{format}', 'webp')
        .replace('{mode}', 'fit');

    return (
        <StyledLogoImage
            srcSet={`${logo} 1x, ${logoRetina} 2x`}
            height={height}
            width={width}
            alt="Logo"
        />
    );
};
